module.exports = __webpack_public_path__ + "static/media/oskar_steffy.bd80bbc6.png";